import { render, staticRenderFns } from "./TestAzML.vue?vue&type=template&id=06ffac26"
import script from "./TestAzML.vue?vue&type=script&lang=js"
export * from "./TestAzML.vue?vue&type=script&lang=js"
import style0 from "./TestAzML.vue?vue&type=style&index=0&id=06ffac26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports